<template>
  <button type="button" role="checkbox" :aria-checked="checked" class="min-h-0 w-5 h-5 border flex-shrink-0 cursor-pointer p-1 flex items-center justify-center transition-all duration-200"
  :class="[
    checked 
    ? 'dark:border-green-800 border-green-600 text-green-600 rounded-full bg-transparent' 
    : ' border-neutral-400 dark:border-neutral-600 rounded-sm bg-neutral-200 dark:bg-neutral-800'
  ]
  "
  @click="toggle"
  :disabled="disabled"
  > 
    <CheckIcon class="w-3 h-3" v-if="checked" />
  </button>
</template>

<script>
import { CheckIcon } from '@heroicons/vue/solid'

export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle'],
  components: { CheckIcon },
  setup(props, { emit }) {

    const toggle = () => {
        emit('toggle')
    }

    return {
      toggle
    }
  }
}
</script>

<style scoped>
</style>